import { EventPriceBenefit } from './event-price-benefit.model';

export class EventBenefit {
  public EventBenefitId: number;
  public EventId: number;
  public BenefitTypeId: number;
  public AdjustmentTypeId: number;
  public BenefitType: string;
  public LimitAmount: number;
  public LimitType: number;
  public EventItems: Array<EventPriceBenefit>;
  public AmountToApply: number;
  public QuantityToApply: number;

  public constructor() {
    this.EventBenefitId = 0;
    this.EventId = 0;
    this.BenefitTypeId = 0;
    this.AdjustmentTypeId = 0;
    this.BenefitType = '';
    this.LimitAmount = 0;
    this.LimitType = 0;

    this.EventItems = new Array<EventPriceBenefit>();

    this.AmountToApply = 0;
    this.QuantityToApply = 0;
  }
}
